var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDark = function SvgDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.1 22q-2.1 0-3.937-.8a10.3 10.3 0 0 1-3.2-2.162 10.3 10.3 0 0 1-2.163-3.2A9.8 9.8 0 0 1 2 11.9q0-3.65 2.325-6.437T10.25 2a10.1 10.1 0 0 0 .275 4.838 9.87 9.87 0 0 0 2.5 4.137 9.87 9.87 0 0 0 4.138 2.5A10.1 10.1 0 0 0 22 13.75q-.65 3.6-3.45 5.925T12.1 22"
  })));
};
export default SvgDark;